export class POItemIdRequest {
    poItemId: number;
    constructor(poItemId: number) {
        this.poItemId = poItemId;
    }
}